export const DEFAULT_FLOW_ID = 'default';
export const LANGUAGE_SELECTION_FLOW_ID = 'language_selection';

export const NODE_TYPES = {
  CONTENT: 'ContentNode',
  INPUT: 'InputNode',
  REDIRECT: 'RedirectNode',
  PAGE: 'PageNode',
  QUESTION: 'QuestionNode'
};
